import { mount } from 'svelte';
import { bootstrapShared } from '@2k48/shared';

import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';
import './styles/components.css';
import './styles/game.css';
import './styles/mockup-system.css';
import './styles/debug.css';
import './styles/views/menu.css';
import './styles/views/play.css';
import './styles/views/solo.css';
import './styles/views/versus.css';
import './styles/views/rankings.css';
import './styles/views/history.css';
import './styles/views/profile.css';
import './styles/views/achievements.css';
import './styles/views/highscores.css';
import './styles/views/settings.css';
import './styles/views/auth.css';

import App from './App.svelte';
import { DEBUG_ENABLED } from './game/debug/metrics';
import { DebugOverlay } from './game/debug/DebugOverlay';
import { installInspector } from './game/debug/inspect';
import { applyMotionTokens } from './game/motion';
import { audio } from './audio/AudioManager';
import { haptics } from './platform/haptics';
import { settings } from './ui/stores/settings.svelte';
import { installUiFeedback } from './platform/feedback';
import { isNative } from './platform/native';

/**
 * Client bootstrap. Order matters here in one place: the registries have to be
 * filled before any view can ask for a mode.
 */

bootstrapShared();

// Push the tunables from shared/balance.ts into CSS custom properties, so a
// GSAP tween and a CSS transition are driven by the same numbers.
applyMotionTokens();

// Preferences load immediately, while the AudioContext itself is deliberately
// created only after the first real gesture to satisfy browser autoplay rules.
void audio.init();
void haptics.init();
// Display preferences are applied before the first paint: loading them later
// would flash a CRT the player had turned off on every cold start.
void settings.init();
installUiFeedback();

if (DEBUG_ENABLED) {
  // `?debug=1`. Mounted on <body>, outside the app frame, so it is never inside
  // anything that animates.
  new DebugOverlay(document.body);
  // Read-only handle for the visual audit; see game/debug/inspect.ts.
  installInspector();
}

if (isNative) {
  // Status bar styling is native-only and must not be awaited on the web, where
  // the plugin is a no-op that would just add startup latency.
  void import('./platform/statusBar').then((m) => m.configureStatusBar());
}

const target = document.getElementById('app');
if (!target) throw new Error('#app is missing from index.html');

mount(App, { target });

// The service worker is registered by vite-plugin-pwa's injected registration
// (registerType: autoUpdate). Nothing to do here.
